import { render } from "./menuStartOptions.vue?vue&type=template&id=2be6dd72&scoped=true"
import script from "./menuStartOptions.vue?vue&type=script&lang=js"
export * from "./menuStartOptions.vue?vue&type=script&lang=js"

import "./menuStartOptions.vue?vue&type=style&index=0&id=2be6dd72&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2be6dd72"

export default script